import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import global from './global';
import hotel from './hotel';
import justExplore from './justExplore';
import location from './location';
import facility from './facility';
import activity from './activity';
import restaurant from './restaurant';
import news from './news';
import accommodation from './accommodation';
import banner from './banner';
import attraction from './attraction';
import popup from './popup';

const reducers = combineReducers({
	routing: routerReducer,
	global,
	hotel,
	justExplore,
	location,
	facility,
	activity,
	restaurant,
	news,
	accommodation,
	banner,
	attraction,
	popup,
});

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js